import { MerchantAccountTypes, MerchantEntityTypes, OnboardingStatuses, useMerchantQry } from 'mmfintech-backend-api'
import { useEffect, useMemo, useState } from 'react'

type OnboardingStep = 0 | 1 | 2 | 3

export const useOnboardingStep = () => {
  const [currentOnboardingStep, setCurrentOnboardingStep] = useState<OnboardingStep>(0)

  const { merchant } = useMerchantQry()

  const totalSteps = useMemo(
    () => (merchant?.entityType === MerchantEntityTypes.INDIVIDUAL ? 2 : 3),
    [merchant?.entityType]
  )

  useEffect(() => {
    if (merchant?.accountType === MerchantAccountTypes.PROSPECT) {
      switch (merchant?.onboardingStatus) {
        case OnboardingStatuses.NOT_STARTED:
          setCurrentOnboardingStep(0)
          break

        case OnboardingStatuses.IN_PROGRESS:
        case OnboardingStatuses.WAITING_QUESTIONNAIRE:
          setCurrentOnboardingStep(1)
          break

        case OnboardingStatuses.UNDER_REVIEW:
        case OnboardingStatuses.WAITING_ADDITIONAL_DOCUMENTS:
        case OnboardingStatuses.WAITING_BUSINESS_AGREEMENT_APPROVAL:
        case OnboardingStatuses.WAITING_COMPLIANCE_APPROVAL:
        case OnboardingStatuses.WAITING_OPS_APPROVAL:
        case OnboardingStatuses.DORMANT:
        case OnboardingStatuses.APPROVED_EXPIRING_DOCUMENT:
        case OnboardingStatuses.REJECTED_RETRY:
        case OnboardingStatuses.REJECTED_EXPIRED_DOCUMENT:
          setCurrentOnboardingStep((totalSteps - 1) as OnboardingStep)
          break

        // case OnboardingStatuses.WAITING_APPLICATION_FEE:
        // case OnboardingStatuses.APPROVED:
        // case OnboardingStatuses.REJECTED_FINAL:
        // case OnboardingStatuses.INELIGIBLE:
        default:
          setCurrentOnboardingStep(totalSteps)
          break
      }
    } else {
      setCurrentOnboardingStep(totalSteps)
    }
  }, [merchant?.accountType, merchant?.onboardingStatus])

  return {
    currentOnboardingStep,
    totalSteps
  }
}
